export default __webpack_public_path__ + "static/media/ranesmini.adbd3cad.jpg";